/**
 * @generated SignedSource<<6ded9222c21e2e0635cb37072c9c3096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorCateringSettings_data$data = {
  readonly allCateringOptions: ReadonlyArray<{
    readonly etgKey: string | null;
    readonly id: string;
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CateringOptionName_cateringOption">;
  }>;
  readonly " $fragmentType": "RoomRatesEditorCateringSettings_data";
};
export type RoomRatesEditorCateringSettings_data$key = {
  readonly " $data"?: RoomRatesEditorCateringSettings_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorCateringSettings_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CateringOption",
      "kind": "LinkedField",
      "name": "allCateringOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "etgKey",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CateringOptionName_cateringOption"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ccc61cf1f0af6dc8c177a7d1e46148d6";

export default node;
